import { Modal } from 'antd';
import { useState } from 'react';

interface IProps {
  url: string;
}

export const VideoPreview: React.FC<IProps> = ({ url }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <video
        src={url}
        width={64}
        height={64}
        style={{ objectFit: 'cover', cursor: 'pointer', borderRadius: 8 }}
        muted
        loop
        onClick={() => setOpen(true)}
      />

      <Modal open={open} footer={null} onCancel={() => setOpen(false)} width={500} centered>
        <video src={url} controls style={{ width: '100%' }} />
      </Modal>
    </>
  );
};
